// Shared by the contact form (inline errors) and the API route (authoritative check).

export const CONTACT_TOPICS = [
  "הצעת מחיר למערכת ניטור חדשה",
  "התייעצות על צורכי ניטור",
  "הרחבה של מערכת קיימת",
  "תמיכה ללקוח קיים",
  "אחר",
] as const;

export type ContactField = "name" | "email" | "phone" | "organization" | "topic" | "message";

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidPhone(value: string) {
  if (!/^[+\d\s().-]+$/.test(value)) return false;
  const digits = value.replace(/\D/g, "").length;
  return digits >= 7 && digits <= 15;
}

export function validateContactFields(fields: Record<ContactField, string>) {
  const errors: Partial<Record<ContactField, string>> = {};
  const name = fields.name.trim();
  const email = fields.email.trim();
  const phone = fields.phone.trim();
  const message = fields.message.trim();

  if (!name) errors.name = "נא להזין שם מלא.";

  if (!email) errors.email = "נא להזין כתובת אימייל.";
  else if (!EMAIL_PATTERN.test(email))
    errors.email = "כתובת האימייל אינה תקינה. לדוגמה: name@example.ac.il";

  if (phone && !isValidPhone(phone))
    errors.phone = "מספר הטלפון אינו תקין. אפשר להזין ספרות, רווחים, מקפים וקידומת +.";

  if (fields.topic && !(CONTACT_TOPICS as readonly string[]).includes(fields.topic))
    errors.topic = "נא לבחור נושא מהרשימה.";

  if (!message) errors.message = "נא לכתוב במה נוכל לעזור.";

  return errors;
}
